<template>
    <ModalComponent name="crear-carpeta" title="Crear carpeta" @close="() => close(false)">
        <FormCarpeta :loading="loading" @submit="submit" />
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormCarpeta from "@/components/backend/components/FormCarpeta";

    export default {
        data() {
            return {
                loading: false,
            };
        },
        methods: {
            close(borrado) {
                this.$emit("close", "crear-carpeta", borrado);
            },
            async submit(data) {
                this.loading = true;
                this.$emit("guardar", data);
                this.close(true);
                this.loading = false;
            },
        },
        components: {
            ModalComponent,
            FormCarpeta,
        },
    };
</script>
